
import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { setBusy, clearBusy, openGeneralDialog, closeGeneralDialog } from 'irmlib/containers'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { Box, Typography, Grid } from '@mui/material'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import MaterialTable from '../../Controls/MaterialReactTable'
import { useLocation, useHistory } from 'react-router-dom'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import { MainRouteSubRoutePage } from '../../AppControl/RoutePage'
import GoBackSubtitle from '../../Controls/GoBackSubtitle'
import { XDivider } from 'irmlib/styles'
import { ThemeButton, ContainedButton } from 'irmlib/components/Controls'
import { CancelButton } from 'irmlib/components/FormControls'
import * as routePaths from '../../../navigation/routePaths'
import { successToast } from '../../../common/functions'
import CircularProgressWithLabel from '../../../irmlib/src/components/Controls/CircularProgressWithLabel'

/* eslint-disable */

const BottomPaddedDiv = styled('div')`
  padding-bottom: 20px;
`
const BottomPaddedButton = (props) => (
  <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: '20px' }}>
    <ThemeButton {...props} />
  </div>
)

const TableContainer = styled(BottomPaddedDiv)``

const BatchTransmittalDetails = (props) => {
  const { state } = useLocation()
  const { batchId, persist, region, refImage, tempId, tempName, template, addRefImg, addRefImgUri, numOfBoxes, selectedTemplateType, buildingID, wmsIns, distId, accntLevel1, accntLevel2, accntLevel3, fromViewBoxTransmittal, offshoreExcl } = state
  const value = props.FilterData
  const { t } = useTranslation()
  const [transmittalData, setData] = React.useState([])
  const [templateDataList, setTemplateDataList] = useState(false)
  const [editedRows, setEditedRows] = useState([])
  const [isError, setIsError] = useState(false)
  const [isBusy, setIsBusy] = useState(false)
  const [progress, setProgress] = useState(0)
  const history = useHistory()

  useEffect(async () => {
    setTemplateDataList(false)
    getPageData()
  }, [value])

  useEffect(() => {
  const unsubscribe = gdeTransactions.listenTransmittalsByBatchId('listener', batchId, setTemplateDataList)

  return () => {
    if (typeof unsubscribe === 'function') {
      unsubscribe()
    }
  }
}, [batchId])


  useEffect(async() => {
    getPageData()
  }, [templateDataList])

  const dataRet = async (val) => {
    setBusy()

    let collection
    if (templateDataList) {
      collection = templateDataList
    } else {
      collection = await gdeTransactions.listenTransmittalsByBatchId('normal', batchId, false)
    }

    const activityList = []

    for (const doc of collection.docs) {
      const docData = doc.data()
      const {
        id,
        accountLevel1,
        batchId,
        building,
        formatError,
        status,
        createdTs,
        imgDetails,
        imgReference,
        template,
        wmsStatus,
        wmsRegion,
        idp,
      } = docData

      let dateOfCreation = false
      if (createdTs) {
        dateOfCreation = moment(createdTs.seconds, 'X').format('YYYY-MM-DD')
      }

      if (dateOfCreation === 'Invalid date') {
        dateOfCreation = createdTs.substring(0, 10)
      }

      const templateFields = Object.keys(template).map(
        (key) => `${key}(${template[key].fieldId}), `
      );

      if (status === 'unapproved') {
        activityList.push({
          id,
          customerId: accountLevel1,
          building,
          batchId,
          formatError,
          status,
          dateCreated: dateOfCreation,
          imgDetails,
          imgReference,
          wmsStatus,
          wmsRegion,
          fields: templateFields,
          exception: idp?.exception,
      })
      }
    }

    setData(activityList)
    clearBusy()

    return activityList
  }


  const getPageData = async (page, pageSize) => {
    try {
      const data = await dataRet(value)
      return data
    } catch (error) {
      console.error('Error fetching page data:', error)
      return []
    }
  }

    const onCancel = () => {
    closeGeneralDialog()
  }

  const updateTransmittals = async () => {
    closeGeneralDialog()
  try {
    setIsBusy(true);
    setProgress(0);

    const total = editedRows.length;
    let completed = 0;

    // Loop through rows sequentially
    for (const row of editedRows) {
      const { id, imgDetails } = row;

      const updatedData = {
        imgDetails: {
          ...imgDetails,
          numOfFiles: parseInt(imgDetails?.numOfFiles) || 0,
        },
        status: "pending",
      };

      await gdeTransactions.updateTransmittal(id, updatedData);

      completed += 1;
      const value = Math.round((completed / total) * 100)
      setProgress(value);
    }

    successToast({ message: t('toast.bulkApprove'), autoHideDuration: 3000, closeIcon: true });

    setIsBusy(false);
    closeGeneralDialog();

    if (!fromViewBoxTransmittal && tempId !== '') {
      haveMoreUpload();
    } else {
      viewBulkUpload();
    }
  } catch (error) {
    setIsBusy(false);
    console.error('Error updating rows:', error);
  }
    }

    const viewBulkUpload = () => {
      const transmittalType = 'batch'
      history.push(routePaths.viewBoxTransmittals, { transmittalType })
      closeGeneralDialog()
    }

    const morebulkUpload = () => {
      closeGeneralDialog()
      history.push(routePaths.uploadBoxTransmittals, { persist, region, refImage, tempId, tempName, template, addRefImg, addRefImgUri, numOfBoxes, selectedTemplateType, buildingID, wmsIns, distId, accntLevel1, accntLevel2, accntLevel3, offshoreExcl })
    }

  const haveMoreUpload = async () => {
        openGeneralDialog({
          title: t('smartCatalog.moreTransmittalWarning'),
          noTranslateTitle: true,
          message: t('smartCatalog.moreTransmittalConfirm'),
          buttons:
  <>
    <CancelButton onClick={viewBulkUpload} />
    <XDivider width='10px' />
    <ContainedButton onClick={morebulkUpload}>buttons.yes</ContainedButton>
  </>,
          closeX: true
        })
  }


  const approveTransmittals = async () => {
          openGeneralDialog({
            title: t('smartCatalog.bulkUploadWarning'),
            noTranslateTitle: true,
            message: t('smartCatalog.approveCofirmationMsg'),
            buttons:
    <>
      <CancelButton onClick={onCancel} />
      <XDivider width='10px' />
      <ContainedButton onClick={updateTransmittals}>buttons.yes</ContainedButton>
    </>,
            closeX: true
          })
        }

  
    // Breadcrumbs
    const breadcrumbs = [
      <Typography sx={{ color: 'text.primary' }}>
        {t('templates.batchId')}
      </Typography>,
      <Typography sx={{ color: 'text.primary' }}>
        {batchId}
      </Typography>,
    ]
  
    const BreadCrumbsComponent = () => {
      return (
      <Breadcrumbs separator='›' aria-label='breadcrumb'>
          {breadcrumbs}
      </Breadcrumbs>
      )
    }

  return (
    <MainRouteSubRoutePage
        mainTitle={t('routeTitles.bulkUploadDetails')}
        subTitle={<><GoBackSubtitle id={'BoxImageDetails_goBack'} onClickBack={() => fromViewBoxTransmittal ? viewBulkUpload() : morebulkUpload()}/>
        <BreadCrumbsComponent /></>}
    >
      <TableContainer>
        <Box boxShadow={3} borderRadius={4}>
          <Grid item container sx={{ padding: '10px 15px 0px' }}>
            <Grid item container alignItems={'center'}>
              <Typography variant='h6' gutterBottom style={{ marginTop: '15px', color: '#58595B' }}>
                {t('routeTitles.bulkUpload')}
              </Typography>
            </Grid>
          </Grid>
          <MaterialTable
            data={transmittalData}
            activeTab={'bulk_upload_review'}
            tableFor='bulk_upload_transmittals'
            editedRows={editedRows}
            setEditedRows={setEditedRows}
            isError={isError}
            setIsError={setIsError}
            disableRowSelection={true}
          />
        </Box>
      </TableContainer>
      <BottomPaddedButton id={'dataEntry_button_select_fieldstoupdate'} disabled={isError} onClick={() => { approveTransmittals() }} variant='contained' color='primary'>
          buttons.bulkApprove
      </BottomPaddedButton>
      {isBusy && <CircularProgressWithLabel msg={t('messages.bulkApproveInfo')} value={progress} sufix={'%'}/>}
    </MainRouteSubRoutePage>
  )
}
BatchTransmittalDetails.propTypes = {
  FilterData: PropTypes.object,
  // DataSearch: PropTypes.string,
}

export default BatchTransmittalDetails